import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Crowdstrike = (props: TIconProps): ReactElement => (
  <svg
    version="1.1"
    viewBox="0 0 27 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      id="crowdstrike_layer_5_"
      fill="hsl(from hsl(0 100% 49%) h s 50%)"
      d="M25.5,16.9c-0.6-0.1-1.6-0.2-2.9,0.4c-1.3,0.6-1.8,0.7-2.4,0.6c0.2,0.3,0.6,0.8,1.7,0.9
	c1.2,0.1,1.7,0.1,1.1,1.6c0-0.4-0.1-1.3-1.3-1.1c-1.2,0.2-1.4,1.2-0.2,1.7c-0.4,0.1-1.3,0.1-1.9-1.5c-0.4,0.2-1.1,0.6-2.3-0.4
	c0.4,0.2,0.9,0.2,0.9,0.2c-1.1-0.5-2.1-1.4-2.7-2.3c0.5,0.4,1.1,0.8,1.7,0.8c-0.7-0.8-2.2-2.5-4.2-4.2c1.2,0.8,2.7,2.1,5.2,1.8
	C20.7,15.1,22.3,14.5,25.5,16.9"
    />
    <path
      id="crowdstrike_layer_4_"
      fill="hsl(from hsl(0 100% 49%) h s 50%)"
      d="M15,16.3c-1.5-0.7-1.9-0.8-3.8-1.3c-2-0.5-3.9-1.5-5.2-3.2c0.9,0.7,2.8,2,4.7,1.9
	c-0.3-0.4-0.8-0.8-1.5-1.1C10,12.8,12.1,13.3,15,16.3z"
    />
    <path
      id="crowdstrike_layer_3_"
      fill="hsl(from hsl(0 100% 49%) h s 50%)"
      d="M11.7,10.6c-0.4-1.1-1.1-2.6-4.5-4.7C5.6,4.8,3.2,3.5,0,0c0.2,0.9,1.2,3.4,6.3,6.5
	C7.9,7.7,10.1,8.4,11.7,10.6"
    />
    <path
      id="crowdstrike_layer_2_"
      fill="hsl(from hsl(0 100% 49%) h s 50%)"
      d="M11.9,12.3c-0.4-1-1.2-2.2-4.5-3.9C5.9,7.5,3.3,6.2,1,3.7C1.2,4.6,2.3,6.6,6.9,9
	C8.2,9.7,10.4,10.4,11.9,12.3"
    />
    <path
      id="crowdstrike_layer_1_"
      fill="hsl(from hsl(0 100% 49%) h s 50%)"
      d="M24.3,14.8c1.2,0.2,1.1,0.4,1.2,0.9C24.9,15.1,24.3,14.8,24.3,14.8z M15.1,7.3
	C8.7,5.5,6.2,3.2,4.2,0.8c0.9,2.8,3,3.8,5.3,5.6c2.3,1.9,2.4,2.9,3.1,4c1.5,2.4,1.7,2.9,3.2,3.9c1.7,1.2,3.9,0.4,6.2,0.7
	c2.3,0.4,4.2,2.1,4.7,2.8c0.5-0.9-0.7-2.1-1-2.4c0.2-1.1-2.5-1.6-3.5-2c-0.2-0.1-0.7-0.2-0.3-1.2C22.4,10.8,23,9.6,15.1,7.3"
    />
  </svg>
);
